/*global _ */
import {name, mixins, props, components, data, EventBus} from './config'
export default {
  name,
  mixins,
  props,
  components,

  data() {
    return {
      selected: null,
      showLogoutConfirmation: false,
      showUserVerificationPrompt: false
    }
  },

  computed: {
    childSlots() {
      const parentSlots = this.$parent.$slots
      const thisSlots =  this.$slots
      const type = this.selected
      const slots = {
        ..._.pickBy(parentSlots, (i, k) => _.startsWith(k, `${type}-`)),
        ..._.pickBy(thisSlots, (i, k) => _.startsWith(k, `${type}-`))
      }
      return slots
    },
    selectedComponent() {
      const menu = this.menu.find(x => x.key === this.selected) || this.menu[0]
      return menu.component
    },
    userLandedAfterSignIn() {
      const parts = document.referrer.split('/');
      return parts[parts.length-1] === 'sign-in';
    },
  },

  async created() {
    EventBus.$emit('profile.created', this)
    await this.pingUser()
    if (!this.showLoginBox) {
      this.authGuard(this)
    }

    EventBus.$on('user.logout', () => {
      if (!this.showLoginBox) {
        this.authGuard(this)
      }
    })

    if (this.user) {
      this.selectDefault()
      if (!this.user.verified) {
        this.showUserVerificationPrompt = true
      }
    }
  },

  async updated() {
    if (!this.selected) {
      this.selectDefault()
    }
  },

  mounted() {
    if (this.userLandedAfterSignIn && this.user) {
      this.addUserHistoryRecord(
        this.user.email,
        _.get(this.userHistoryActions, 'user_landed_to_profile_after_sign_in.name')
      )
    }
  },
  methods: {
    getMenuItemClass(key) {
      return [
        'tab-menu-item',
        _.kebabCase(`tab-menu-item-${key}`),
        this.$$s(`menu.${key}.class`),
        {
          active: this.active(key)
        }
      ]
    },
    getSelectedMenuFromUrl() {
      const hash = window.location.hash.replace(/^#/, '')
      return this.menu.find(x => x.key == hash) || this.menu[0]
    },
    selectDefault() {
      const menu = this.getSelectedMenuFromUrl()
      this.select(menu)
    },
    select(item) {
      if (_.isObject(item)) {
        item = item.key
      }
      window.location.hash = item
      this.selected = item
      EventBus.$emit('profile.select-tab', item)
    },
    active(item) {
      return this.selected === item
    },
    getProfileTabAttrs(name) {
      const otherAttrs = this.mergedAttr
      const translations = this.$$clone(this.$$t(`tab.${name}`, this.$t('this')))
      const settings = this.$$clone(this.$$s(`tab.${name}`, this.$$s()))
      const attr = {
        translations,
        settings,
      }
      return attr
    },
    getComponentExtraClasses() {
      return [`selected-tab-${this.selected}`]
    }
  },
}
